import { render, staticRenderFns } from "./VeidoPlayer.vue?vue&type=template&id=12c3e441&"
import script from "./VeidoPlayer.vue?vue&type=script&lang=js&"
export * from "./VeidoPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports